"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const defaultScormData_1 = tslib_1.__importDefault(require("./defaultScormData"));
function addDefaultScorm(content, state) {
    try {
        if (content.content.subType === 'scorm') {
            const scorm = Object.assign({}, { scormData: defaultScormData_1.default });
            return Object.assign(state, { scorm });
        }
        return state;
    }
    catch (error) {
        throw new Error('Error in addDefaultScorm ' + error);
    }
}
exports.default = addDefaultScorm;
//# sourceMappingURL=addDefaultScorm.js.map